<template>
  <div class="mt-4">
    <!-- <CRow class="mb-2">
      <CCol class="font-weight-bold">
        <label>Note</label>
      </CCol>
    </CRow>

    <CDropdownDivider/>

    <CRow class="mt-3">
      <CCol> -->
        <!-- QEditor ต้องรับ object -->
        <!-- <QEditor :content="noteObj" />
      </CCol>
    </CRow>

    <small v-if="saving" class="text-info">กำลังบันทึก...</small>
    <small v-if="saveError" class="text-danger">บันทึกไม่สำเร็จ</small> -->
    
  <CCard class="bg-style2" >
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius:1rem;border-top-right-radius:1rem">
        <span class="font-weight-bold h6">
          <CIcon name="cil-notes" size="lg"/> Note
        </span>
      </CCardHeader>

      <CCardBody>
        <CRow class="">
      <CCol>
        <!-- QEditor ต้องรับ object -->
        <QEditor :content="noteObj" />
      </CCol>
    </CRow>

    <small v-if="saving" class="text-info">กำลังบันทึก...</small>
    <small v-if="saveError" class="text-danger">บันทึกไม่สำเร็จ</small>
      </CCardBody>
      
  </CCard>

  </div>

  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import debounce from "lodash/debounce";
import QEditor from "@/projects/components/Util/QEditor";

export default {
  name: "Note",
  components: { QEditor },
  props: { caseId: { type: String, required: true } },
  data() {
    return {
      noteObj: { value: "" }, // object สำหรับ QEditor
      saving: false,
      saveError: false,
    };
  },
  computed: {
    ...mapGetters("Dashboard", ["reports"]),
    report() {
      return this.reports.find(r => r._id === this.caseId) || null;
    },
  },
  watch: {
    report: {
      immediate: true,
      handler(newVal) {
        this.noteObj.value = newVal?.notes || "";
      }
    },
    'noteObj.value': {
      handler() { this.debouncedSave(); }
    }
  },
  methods: {
    ...mapActions("Dashboard", ["updateNote"]),
    saveNote() {
      if (!this.report) return;
      this.saving = true;
      this.saveError = false;
      this.updateNote({
        reportId: this.report._id,
        notes: this.noteObj.value
      })
      .then(() => { this.saving = false; })
      .catch(() => { this.saving = false; this.saveError = true; });
    },
    debouncedSave: debounce(function() { this.saveNote(); }, 800)
  }
};
</script>
